<template>
    <div id="contents">
        <div class="contents_wrap">
            <!--<OBJECT
                id="unetTS"
                classid="clsid:1F529230-5B55-4C17-80A0-70F19821A033"
                codebase="/static/setup/SecuiGSPNIE.cab#Version=4,0,0,7"
                :onerror="onTrustNetError"
                width="0"
                height="0"
            ></OBJECT>
            <OBJECT
                id="TrustNETCAClient"
                classid="clsid:C4A97BC6-0E15-46C1-9A7D-2E9465E51C48"
                codebase="/static/setup/SecuiGSPNIE.cab#Version=1,0,0,1"
                :onerror="onTrustNetError"
                width="0"
                height="0"
            ></OBJECT>--><!-- CB Trustnet Client 교체 22.10.12 --> 
            <h2 class="pg_title">Mobile Authorization</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Mobile SVC
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Mobile Authorization
            </div>
            <!-- //breadcrumbs -->
            <!--dubblebox-->
            <div class="box_wrap">
                <div v-if="loginYN === 'Y'" style="text-align: center; width: 100%;">
                    <otp />
                    <h4 style="font-size: 1.2em; margin-bottom: 8px; margin-top: 16px;">Browser Plugin</h4>
                    <div style="position: relative;">
                    	<span style="display: block;position: absolute;top: -24px;right: 110px;">
                    		<a
                    			target="_blank"
                                href="/static/setup/MobileSVC_Installation_Guide.pdf"
                            >Mobile SVC Installation Guide <img src="/static/images/ico_attach.png" alt />
                            </a>
                        </span>
                    </div>
                    <table class="data_table_ty2">
                        <colgroup>
                            <col width="70%" />
                            <col/>
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="text_center">Type</th>
                                <th class="text_center">Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text_left">Online (Web Store Download)</td>
                                <td class="text_left">
                                    <a
                                        :href="STORE_CHROME"
                                    >Chrome Store <img src="/static/images/ico_attach.png" alt />
                                    </a>
<!--                                     <br /><br /> -->
<!--                                     <a -->
<!--                                         :href="STORE_MSEDGE" -->
<!--                                     >MSEdge <img src="/static/images/ico_attach.png" alt /> -->
<!--                                     </a> -->
                                </td>
                            </tr>
							<tr>
                                <td class="text_left">
	                                <div class="accordion_wrap toggle_close">
			                            <header @click="clickToggle">Offline (SKP Download)<span style="color: red">&nbsp;&nbsp;&nbsp;* Note: Please use this SKP local downloading only when plug-in is not downloaded online.</span>
			                            </header>
			                            <ul class="ul_list">
			                            	<br />※If you install an extension through manual installation, it is disabled so that you cannot delete the extension.
			                                <br />　(It can be deleted when installed in the web store)
			                                <br />　It is recommended to install an extension program in the web store, and if you cannot access the web store, please use it.
			                                <br /><br />
			                                □ Manual installation method:<br />
											1. Please unzip the attached file to the path below.<br />
											- Target file: crx.crx /jnobgabnnbdhjompaagbfbjiimplamll.xml /reg_Chrome.reg / reg_Edge.reg<br />
											- Path: C:\Windows\pcdrm\dump<br />
											<br />
											2. Reg file execution<br />
											- reg_Chrome.reg(Chrome extension program added)<br />
											- reg_Edge.reg(Add edge extension program)<br />
											<br />
											3. After about 30 seconds, enter the path below in the address input line to check for extended installation<br />
											- Chrome chrome://extensions<br />
											- Edge edge://extensions/<br />
			                            </ul>
			                        </div>
								</td>
                                <td class="text_left">
                                    <a href="/static/setup/drm-offline.zip">Offline&nbsp;&nbsp;&nbsp;&nbsp;<img src="/static/images/ico_attach.png" alt /></a>
                                </td>
							</tr>
                        </tbody>
                    </table>
                    <h4 style="font-size: 1.2em; margin-bottom: 8px; margin-top: 16px;">NASCA Client</h4>
                    <table class="data_table_ty2">
                        <colgroup>
                            <col width="70%" />
                            <col/>
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="text_center">Type</th>
                                <th class="text_center">Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text_left">NASCA Client</td>
                                <td class="text_left">
                                    <a
                                        href="/static/setup/NASCA_SD_5.00_32bit.exe"
                                    >NASCA 32Bit OS <img src="/static/images/ico_attach.png" alt />
                                    </a><br /><br />
                                    <a
                                        href="/static/setup/NASCA_SD_5.00_64bit.exe"
                                    >NASCA 64Bit OS <img src="/static/images/ico_attach.png" alt />
                                    </a><br /><br />
<!--                                     <a -->
<!--                                         href="/static/setup/nsd_5.00.exe" -->
<!--                                     >Non-NASCA 32/64Bit OS <img src="/static/images/ico_attach.png" alt /> -->
<!--                                     </a> -->
                                    <a
                                        href="/static/setup/NSD_5.00_2022070420.exe"
                                    >Non-NASCA 32/64Bit OS <img src="/static/images/ico_attach.png" alt />
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- CB 2022.10.14 NASCA Server DRM WS
                <div v-if="loginYN === 'Y'" style="text-align: center; width: 100%;>
                    <otp />
                    <h4 style="font-size: 1.2em; margin-bottom: 8px; margin-top: 16px;">DRM Client Download</h4>
                    <table class="data_table_ty2">
                        <colgroup>
                            <col width="43%" />
                            <col width="47%" />
                            <col width="10%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="text_center">Type</th>
                                <th class="text_center">Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text_center">NASCA Active X</td>
                                <td class="text_center">
                                    <a
                                        href="/static/setup/NSD_ActiveX_Installer.exe"
                                    >
                                        <img src="/static/images/ico_attach.png" alt />
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td class="text_center">NASCA 32Bit OS</td>
                                <td class="text_center">
                                    <a
                                        href="/static/setup/NASCA_SD_5.00_32bit.exe"
                                    >
                                        <img src="/static/images/ico_attach.png" alt />
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td class="text_center">NASCA 64Bit OS</td>
                                <td class="text_center">
                                    <a
                                        href="/static/setup/NASCA_SD_5.00_64bit.exe"
                                    >
                                        <img src="/static/images/ico_attach.png" alt />
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td class="text_center">Non-NASCA 32/64Bit OS</td>
                                <td class="text_center">
                                    <a
                                        href="/static/setup/nsd_5.00.exe"
                                    >
                                        <img src="/static/images/ico_attach.png" alt />
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> CB 2022.10.14 NASCA Server DRM WS -->
                <div v-else class="login_wrap">
                    <div class="item_login loginD" v-if="pinYN === 'T'">
                        <div>You first need to obtain an access to Mobile.</div>
                    </div>

                    <div class="item_login loginT" v-if="pinYN === 'Y' && loginYN !== 'Y'">
                        <ul class="w100">
                            <li class="sub_tit">Certificates Password</li>
                            <li class="mt20">
                                <span class="clearable">
                                    <input
                                        type="password"
                                        class="text_input w100"
                                        v-model="certPwd"
                                        placeholder
                                        minlength="4"
                                        maxlength="24"
                                        @keyup.enter="doLogin()"
                                        v-validation
                                        v-clearable
                                        value
                                    />
                                </span>
                            </li>
                            <li>
                                <a
                                    href="javascript:"
                                    class="btn_blue w100 h40 mt10"
                                    title
                                    @click="doLogin()"
                                >Login</a>
                            </li>
                        </ul>
                        <ul class="login_L_txt">
                            <li v-if="loginLockYN === 'Y' || monthLockYN === 'Y'">
                                If your account is locked, request an unlock
                            </li>
                            <li v-if="loginLockYN === 'Y' || monthLockYN === 'Y'">
                                <router-link
                                    to="/basis/anysvcmobile/request/RequestOther"
                                    class="txt_link"
                                >Other Request</router-link>
                            </li>
<!--                             <li class="mt40">Windows Certificates Plugin</li> -->
<!--                                 <a -->
<!--                                     target="_blank" -->
<!--                                     href="/static/setup/TrustNet_Cert_WEBCLIENT_v1.0.0.9.exe" -->
<!--                                 >Download</a> -->
<!--                             </li> -->
                            <li>
                                <a
                                    target="_blank"
                                    href="/static/setup/TrustNet_Cert_WEBCLIENT_v1.0.0.9.exe"
                                >PC Certificate (TrustNet Web Client) <img src="/static/images/ico_attach.png" alt />
                                </a>
                            </li>
                            <li>&nbsp;</li>
                            <li>
                                <a
                                    target="_blank"
                                    href="/static/setup/MobileSVC_Installation_Guide.pdf"
                                >Mobile SVC Installation Guide <img src="/static/images/ico_attach.png" alt /></a>
                            </li>
                        </ul>
                    </div>
                    <div
                        v-if="loginYN === 'Y'"
                        class="item_login loginT"
                        style="height: 100px; line-height: 80px; font-size: 1.5em;"
                    >
                        You are already logged in.
                    </div>

                    <div class="item_login" v-if="pinYN === 'N' && monthLockYN !== 'Y'">
                        <p>
                            Your Access to HHP has been approved but you have not redeemed a certificate yet.
                            <br />Please get a certificate first by using the "Redeem Certificate" button on the right.
                        </p>
                    </div>

                    <div class="item_login">
                        <ul class="login_R_txt">
                            <li>1. If you have not registered or have changed the working PC, click the "Access Request" button below.</li>
                            <li>
                                <router-link
                                    to="/basis/anysvcmobile/request/RequestCert"
                                    class="btn_sm_white"
                                >Access Request</router-link>
                            </li>
                            <li>2. After the approval, you will receive an email with a PIN.</li>
                            <li>3. You can redeem a certificate using the PIN for secure login to Anysvc.</li>
                            <li v-if="pinYN === 'N'" class="issue_go">
                                <a
                                    href="javascript:"
                                    class="btn_sm_white"
                                    id="show-modal"
                                    title
                                    @click="showCertificateIssuePopup"
                                >Redeem Certificate</a>
                            </li>

                            <li>4. The certificate is dedicated to the issued computer. If you change the computer, you must get the certificate reissued.</li>
                            <li>5. Login with password</li>
                        </ul>
                    </div>
                </div>
            </div>
            <!--//dubblebox-->
        </div>
    </div>
</template>

<script>
import Vue                          from 'vue';
import { mapActions, mapGetters }   from 'vuex';
import axios from 'axios';
import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';

import { SDLUtil } from '@/utils';
import CertUtil from '@/utils/CertUtil';

import qs from 'query-string';

import CertIssuePopup from './CertIssuePopup';
import CertInstallPopup from './CertInstallPopup';
import CertLoginSuccessPopup from './CertLoginSuccessPopup';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import { EventBus } from '@/utils/EventBus';
import CertOTP from './CertOTP';

import * as unet from '/static/js/trustnet/TrustNetJsEX';

export default {
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'otp': CertOTP,
    },
    props: [],
    data() {
        return {
            pageTitle: '',

            userId: '',
            certPwd: '',
            pinYN: '',
            monthLockYN: '',
            loginLockYN: '',
            loginYN: 'N',
            macAddress: '',

            // loginData: {
            //     macAddr: '',
            //     signcert: '',
            //     source: '', // CertId + certPassword
            //     signvalue: '',
            //     certId: ''
            //     certPwd: '',
            // },
            unetTS: null,
            STORE_MSEDGE : 'https://microsoftedge.microsoft.com/addons/detail/nasca-server-drm/enfbagebehlaeomhfohjefkfodanciim',
            STORE_CHROME : 'https://chrome.google.com/webstore/detail/nasca-server-drm/jnobgabnnbdhjompaagbfbjiimplamll',
        };
    },
    computed: {},

    created() {
        this.init();
        EventBus.$on('cert-issued', () => {
            this.init();
        });
        EventBus.$on('hhp-login-reload', () => {
            this.init();
        });
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('cert-issued');
        EventBus.$off('hhp-login-reload');
    },
    mounted() {
// CB Trustnet Client 교체 22.9.19
//         this.$nextTick(() => {
//             if (!SDLUtil.isIE11()) {
//                 SDLUtil.alert({
//                     title: 'Unsupported Browser!',
//                     msg: 'Only Internet Explorer 11 is supported.',
//                 });
//                 return;
//             }
//             if (!CertUtil.isTrustNetInstalled()) {
//                 SDLUtil.show(
//                     CertInstallPopup,
//                     {
//                     },
//                     { width: '500px', height: 'auto' },
//                 );
//             }
//         });
        
		//////////////////// 라이선스 설정 ////////////////////////////
// 		const time = "20230229";
// 		const access = ["10.199.114.112", "localhost"];
// 		const signature = "shxoiWov1m6E7CKpwBBugMCWGSMrd7778r+Rg/ktJYQWRNUy0DOQcYCeubnf0fNhJ1JRg0TH6nLXQfet6QKXI7fcUHpR7meXFWR80RrhBukRuXhdIc0xaj99u6cjaEgyWWX5pgTrQr206IfNbsJTHFskdgAf180wkyIaVbpt/aFZRBwyHHbi4ywnfjoZpU/VJsHBhLy3vMQ/r27/x94Ep5NgYN71AUUTlG3deaddNt4mVKtLavOM0RBiQeHiJ7wdPAEn/ie04Zrosx0RvNMjvWUZ6lGlU/uSCvX1WIGYiQ0Hlt3g5788n/Tm7g/7vXx3KhwDrJbYfaekx+oKMkRZcQ==";
//         if (process.env.NODE_ENV === 'prod') {
		const time = "permanent";
		const access = ["skp.samsungcsportal.com"];
		const signature = "uRfuldEhY0RL5LdYgEX1OlTcsNVSN+Mmxmxocb+BbX1Xl8gdj97VmK64FQghgvTaTc6bygJ2VJ8bV1ebgUpz1ViP2/pqP+8XRmaYjP/iN8KSFD3BWfLcygoXxWrX+sjANANt78lsA8Qs+1BfrsLuOUYtYvbcVngydnGT9fGn5j35geR38DnkUKpjNmM69w2R5F0cW1jno4wwHoiSfgJjAOsfhmvWKtadG5H+wwKsdkTAvyqGQlmZKgohMGoYNApcFrKW3PLKd4cNpw+GTH0p9j2pPVtBcuUTT7f1tTVDFp8zU7HGEChqctsXDSoSdDMCMiyGWJZizBLdJvfepeUXnQ==";
//         }
		const LICENSE = {"time":time, "access":access, "signature":signature};
		TrustNetEX.setLicense(LICENSE);
    	//////////////////// 공통 설정 ////////////////////////////
    	TrustNetEX.setUTF8(true);	// UTF8 속성
    },

    methods: {
        async init() {
            const data = await this.fetchInitData();
            this.userId = data.userId;
            this.pinYN = data.pinYN;
            this.monthLockYN = data.monthLockYN;
            this.loginLockYN = data.loginLockYN;
            this.loginYN = data.loginYN || 'N';

            if (this.pinYN === 'Y') {
                // hide D
                // show T
                // hide F
                // hide issue_go
                // show other_go
            }

            const alertMsg = this.checkLock(this.monthLockYN, this.loginLockYN);
            if (alertMsg) {
                SDLUtil.alert({
                    title: 'Account Locked',
                    msg: alertMsg,
                });
                return;
            }
            
        	this.checkTrustNetWebClient();
        },
        
        clickToggle(e) {
        	if( $(e.target).closest("div").hasClass('toggle_close') == true){
        		$(e.target).closest("div").removeClass('toggle_close');
            } else {
            	$(e.target).closest("div").addClass('toggle_close');
            }
        },

        fetchInitData() {
            const path = '/basis/certificate/CertLogin.skp';
            return SDLUtil.getRequest(path);
        },
       	        
        getCertificateSignedData(certId, certPwd) {
            // console.log('certid', certId);
            // console.log('certPwd', certPwd);
			
            const source = certId + certPwd;
            const sAsisOu = 'SAMSUNGGSPN'; // 구인증서 OU
            const sTobeDn = 'CN=' + certId + ',OU=SAMSUNGSCMS,O=SAMSUNG,C=KR'; // 신규인증서 DN
       		const dn = TrustNetEX.tnBase64Encode(sTobeDn);
       		       		       		
            const unetTS = document.getElementById('unetTS');

            const signvalue = unetTS.SignAdv(source, sTobeDn, certId, sAsisOu, certPwd);
            if (unetTS.GetErrorCode() !== 0) {
                const errorMessage = unetTS.GetErrorString();
                const last = errorMessage.indexOf('] ') + 2;
                if (errorMessage.indexOf('There is no Certification') != -1) {
                    SDLUtil.alert({
                        msg: 'There is no certificate.<br>Please, request a new certificate or redeem one.',
                    });
                    return null;
                } else if (errorMessage.indexOf("The private key's password is not correct") != -1) {
                    SDLUtil.alert({ msg: 'Incorrect certificate password.' });
                    return null;
                } else {
                    SDLUtil.alert({ msg: errorMessage.substring(last) + '.' });
                    return null;
                }
                return null;
                // ajaxFailSubmit(param);
            }
            const signcert = unetTS.GetCert();
           return { signcert, source, signvalue };
        },
        
        async doLogin() {
//CB Trustnet Client 교체 22.9.19
//             if (!SDLUtil.isIE11()) {
//                 SDLUtil.alert({
//                     title: 'Unsupported Browser!',
//                     msg: 'Only Internet Explorer 11 is supported.',
//                 });
//                 return;
//             }
//CB Trustnet Client 교체 22.9.19

            const alertMsg = this.checkLock(this.monthLockYN, this.loginLockYN);
            if (alertMsg) {
                SDLUtil.alert({
                    title: 'Account Locked',
                    msg: alertMsg,
                });
                return;
            }
            
//CB Trustnet Client 교체 22.10.12
			
            const _signAdv = new Promise((resolve) => {
	   			// let _userDn = TrustNetEX.tnBase64Encode('CN=' + this.userId + ',OU=SAMSUNGSCMS,O=SAMSUNG,C=KR');// 신규인증서 DN;
	   			let _userDn = TrustNetEX.tnBase64Encode('cn=' + this.userId + ',ou=SAMSUNGSCMS,o=SAMSUNG,c=KR');// 신규인증서 DN;
	   			let sSignSrc = this.userId+this.certPwd;
	   			let sCertPwd = this.certPwd;
	   			TrustNetEX.tnSignAdv(_userDn, sSignSrc, sCertPwd, function(_ret) {
	   				resolve(_ret);
	   			});
	   		});
        	
        	const _ret = await _signAdv;
        	console.log("await _signAdv" + JSON.stringify(_ret));
        	
			if(_ret.retCode === 0){		
	        	
	        	const signvalue = _ret.signature;
	        	const source = this.userId + this.certPwd;
	        	const signcert = _ret.certificate;
	        	const certData = { signcert, source, signvalue };        		
	            const formData = {
	                ...certData, // signcert, source, signvalue
	                macAddr: SDLUtil.getMacAddress(),
	                certId: this.userId,
	                pinYN: this.pinYN,
	                monthLockYN: this.monthLockYN,
	                loginLockYN: this.loginLockYN,
	                certPwd: this.certPwd,
	            };
	
				SDLUtil.showLoadingBar(true);
	            const data = await this.postLogin(formData);
	            if (data.result === 'Y') {
	                SDLUtil.showLoadingBar(false);
	                SDLUtil.show(
	                    CertLoginSuccessPopup,
	                    {},
	                    {
	                        width: '800px',
	                        height: 'auto',
	                    },
	                );
	                return;
	            } else if (data.result === 'N') {
	            	console.log("data.result N : formData", JSON.stringify(formData) );
		            const retdata = await this.postLogin(formData);
		            if (retdata.result === 'Y') {
		                SDLUtil.showLoadingBar(false);
		                SDLUtil.show(
		                    CertLoginSuccessPopup,
		                    {},
		                    {
		                        width: '800px',
		                        height: 'auto',
		                    },
		                );
		                return;
		            } else {
		                this.recordLoginFail(data.message);
		                return;
		            }
	
	            } else if (data.result === 'E') {
	                this.recordLoginFail(data.message);
	                return;
	            }
			} else { //WebClient return 0 이 아닌경우}

	        	SDLUtil.alert({
	                //msg: 'Please install or allow TrustNET Solution to run.',
	                msg : _ret.retMsg,
	            });
	            return;
	        }		            
        },

        async recordLoginFail(failMessage = '') {
                SDLUtil.showLoadingBar(true);
                const failedData = await this.postLoginFailed();
                SDLUtil.showLoadingBar(false);
                this.pinYN = failedData.pinYN;
                this.loginLockYN = failedData.loginLockYN;
                SDLUtil.alert({
                    title: 'Login Failed. :(' ,
                    msg: failMessage
                        + '<br>Account will be locked with too many failed login attempts.',
                    onOkEvt: () => {
                    },
                });
        },

        prepFormData() {
            const certData = this.getCertificateSignedData(this.userId, this.certPwd);
            if (certData == null) return null;

            const formData = {
                ...certData, // signcert, source, signvalue
                macAddr: SDLUtil.getMacAddress(),
                certId: this.userId,
                pinYN: this.pinYN,
                monthLockYN: this.monthLockYN,
                loginLockYN: this.loginLockYN,
                certPwd: this.certPwd,
            };

            return formData;
        },

        postLogin(formData) {
            console.log('Submitting formData:', formData);
            return axios
                .post(`${SDLUtil.API_URL}/basis/certificate/CertLoginProc.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    console.log('POST FORM RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('POST FORM ERROR =>> ', err);
                    return err.data;
                });
        },

        showCertificateIssuePopup() {
            SDLUtil.show(
                CertIssuePopup,
                {
                    title: 'CertificateIssuePopup',
                    class: 'sm_size',
                },
                { width: '500px', height: 'auto' },
            );
        },

        checkLock(monthLockYN, loginLockYN) {
            let str = '';

            if (monthLockYN == '' || loginLockYN == '') {
                str = 'Server Error!!\nPlease contact your administrator.';
            } else if (monthLockYN == 'Y' || loginLockYN == 'Y') {
                if (monthLockYN == 'Y') {
                    if (str != '') {
                        str += '\n';
                    }
                    str += "[ Unlock the 1-month lock ]\nYou haven't logged into your account for more than a month.";
                }
                if (loginLockYN == 'Y') {
                    if (str != '') {
                        str += '\n';
                    }
                    str += '[ Unlock the certificate ]\nLogin failed for more than five times.';
                }
                str += "\nPlease unlock the account by using 'Other request' in Mobile SVC.";
            }
            str = str.replace('\n', '<br>');
            return str;
        },
        
        postLoginFailed() {
            // post to url: "/basis/certificate/CertLoginFailProc.skp?"+param,
            const params = {
                macAddr: this.macAddress,
            };

            return axios
                .post(`${SDLUtil.API_URL}/basis/certificate/CertLoginFailProc.skp`, qs.stringify(params), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(res => {
                    console.log('POST LOGIN FAILED RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('POST LOGIN FAILED ERROR =>> ', err);
                    return err.data;
                });
        },
		checkTrustNetWebClient(){
	    	try {
	    		$.post('https://localhost:18448/alive?'+(new Date).getTime(), {}, function(res) {})
	    		.fail(function() {
		    		$.post('https://localhost:28448/alive?'+(new Date).getTime(), {}, function(res) {})
		    		.fail(function() {
			    		$.post('https://localhost:38448/alive?'+(new Date).getTime(), {}, function(res) {})
			    		.fail(function() {
			                SDLUtil.show(
			                        CertInstallPopup,
			                        {
			                        },
			                        { width: '500px', height: 'auto' },
			                    );
			    		});
		    		});
	    		});
	    	} catch (err) {
	    		console.log('catch', err);
	    	}
        },
//CB Trustnet Client 교체 22.9.19
//         onTrustNetError() {
//             const title = 'TrustNet Error';
//             SDLUtil.alert({
//                 title,
//                 msg:
//                     'Error occurred running TrustNet solution. <br>Please make sure the plugin is installed and allowed to run.',
//             });
//         },
    },
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/certificate/CertLogin.vue